import { ReducerLock } from './ReducerLock';
import { ReducerEntity } from './ReducerEntity';
import { ReducerUser } from './ReducerUser';

export const reducer = {
  lock: ReducerLock.create(),
  entity: ReducerEntity.create(),
  user: ReducerUser.create(),
};